<template>
  <v-page page="a2eScores" title="A2E::LEAD EXPEDITION DEBRIEF" class="blue-grey--text text--darken-1" >
    <v-container class="px-0 mx-0 pt-1 mt-3 pl-3 pr-3">
      <v-layout>
        <v-flex>
          <v-text-field v-model="query"
            :placeholder="this.placeholderText"
            clearable solo
            @keydown.enter="getScores"
            data-test="searchInput">
          </v-text-field>
        </v-flex>
        <v-flex xs2 ml-2>
          <v-select v-model="attribute"
            :items="searchAttributeChoices"
            solo >
          </v-select>
        </v-flex>
        <v-flex class="searchbar-btn" xs2 lg1 ml-2>
          <v-btn @click="getScores" color="primary">Search</v-btn>
        </v-flex>
      </v-layout>
      <v-layout mr-5>
        <v-spacer/>
          <v-csv-downloader
                v-if="false"
                :disabled="a2eG1Scores.length === 0 && a2eG2Scores.length === 0 && a2eG3Scores.length === 0"
                :fields="csvFields"
                :datasource="csvData"
                name="a2eScores"
                buttonText="Download CSV"
                customizable/>
      </v-layout>
    <v-layout row>
      <v-flex>
        <v-toolbar flat dense color="#FAFAFA" class="update-action">
          <h2 class="mb-4 blue-grey--text text--darken-1">
            {{ teamRankingsTitle }}
          </h2>
        </v-toolbar>
        <v-tabs class="elevation-4">
          <v-tab @click="changeTab(a2eG1Title)">
            {{ a2eG1Title }}
          </v-tab>
          <v-tab-item>
            <v-card >
              <v-data-table class="elevation-1 nowrap"
                :headers="g1TableHeaders"
                :items="a2eG1Scores">
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.teamName }}</td>
                    <td>{{ props.item.overallTeamScore }}</td>
                    <td>{{ props.item.bestIndivScore }}</td>
                    <td>{{ props.item.meanIndivScore }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab class="ml-5" @click="changeTab(a2eG2Title)">
            {{ a2eG2Title }}
          </v-tab>
          <v-tab-item>
            <v-card>
              <v-data-table class="elevation-1 nowrap"
                  :headers="g2TableHeaders"
                  :items="a2eG2Scores">
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ props.item.teamName }} </td>
                      <td>{{ props.item.teamScore }}</td>
                      <td>{{ props.item.roundTimeDelta }}</td>
                      <td>{{ props.item.firstStepTime }}</td>
                      <td>{{ props.item.numCracks }}</td>
                      <td>{{ props.item.numCrevasses }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab class="ml-5" @click="changeTab(a2eG3Title)">
              {{ a2eG3Title }}
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-data-table class="elevation-1 nowrap"
                  :headers="g3TableHeaders"
                  :items="a2eG3Scores">
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ props.item.teamName }} </td>
                      <td>{{ props.item.teamDecisionScore }}</td>
                      <td>{{ props.item.experienceScore }}</td>
                      <td>{{ props.item.missionAccomplished }}</td>
                      <td>{{ props.item.kenSaved }}</td>
                      <td>{{ props.item.firstSectionCorrect }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-flex v-if="isG1CategoryKeyActive" pt-3 mt-3>
          <h4>
            {{ a2eG1FooterText1 }}
          </h4>
        </v-flex>
        <v-flex v-if="isG1CategoryKeyActive" pt-3>
          <h4>
            {{ a2eG1FooterText2 }}
          </h4>
        </v-flex>
        <v-layout>
        <v-flex v-if="isTeamAverageFooterActive" pt-3 xs6 mt-5>
          <v-toolbar flat dense color="#FAFAFA" class="update-action">
            <h1 class="mb-4 blue-grey--text text--darken-1">
              {{ teamAveragesTitle }}
            </h1>
          </v-toolbar>
          <v-data-table v-if="isG2TeamAverageFooterActive" class="elevation-1 nowrap"
                :headers="g2FooterTableHeaders"
                :items="a2eG2TeamFooterAverages"
                hide-default-footer>
            <template v-slot:item="props">
              <tr>
                <td>{{ props.item.teamScore }}</td>
                <td>{{ props.item.avgTimeDelta }}</td>
                <td>{{ props.item.firstStepTime }}</td>
                <td>{{ props.item.numCracks }}</td>
                <td>{{ props.item.numCrevasses }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table v-if="isG3TeamAverageFooterActive" class="elevation-1 nowrap"
                :headers="a2eG3FooterTableHeaders"
                :items="a2eG3TeamFooterAverages"
                hide-default-footer>
            <template v-slot:item="props">
              <tr>
                <td>{{ props.item.missionAccomplished }}</td>
                <td>{{ props.item.kenSaved }}</td>
                <td>{{ props.item.accomplishedBoth }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import VCsvDownloader from '@/components/CsvDownloader/CsvDownloader.vue'
import { searchScores } from '@/services/A2eScores'

export default {
  name: 'a2eScores',
  components: {
    VPage,
    VCsvDownloader
  },
  data () {
    return {
      query: '',
      yesResponseString: 'YES',
      noResponseString: 'NO',
      partialResponseString: 'PARTIALLY',
      fullyResponseString: 'FULLY',
      teamRankingsTitle: 'Team Rankings',
      attribute: 'assessment_groups',
      searchAttributeChoices: [
        { value: 'assessment_groups', text: 'Workshop Names', sortable: false },
        { value: 'assessment_ids', text: 'Assessment Ids' },
        { value: 'ids', text: 'Ids' }
      ],
      g1TableHeaders: [
        { text: 'TEAM NAME', value: 'teamName', sortable: false },
        { text: 'TEAM SCORE', value: 'overallTeamScore', sortable: false },
        { text: 'BEST INDIV. SCORE', value: 'bestIndivScore', sortable: false },
        { text: 'MEAN INDIV. SCORE', value: 'meanIndivScore', sortable: false }
      ],
      a2eG1Scores: [],
      a2eG1Title: 'Survival At Sea',
      g1TitleMatches: /survival/i,
      a2eG1FooterText1: '',
      a2eG1FooterText2: '',
      g2TableHeaders: [
        { text: 'TEAM NAME', value: 'teamName', sortable: false },
        { text: 'TIME', value: 'teamScore', sortable: false },
        { text: 'ROUND TIME DELTA', value: 'roundTimeDelta', sortable: false },
        { text: 'TIME BEFORE 1ST STEP', value: 'firstStepTime', sortable: false },
        { text: '# OF CRACKS', value: 'numCracks', sortable: false },
        { text: '# OF CREVASSES', value: 'numCrevasses', sortable: false }
      ],
      a2eG2Scores: [],
      g2FooterTableHeaders: [
        { text: 'TIME', value: 'teamScore', sortable: false },
        { text: 'ROUND TIME DELTA', value: 'roundTimeDelta', sortable: false },
        { text: 'TIME BEFORE 1ST STEP', value: 'firstStepTime', sortable: false },
        { text: '# OF CRACKS', value: 'numCracks', sortable: false },
        { text: '# OF CREVASSES', value: 'numCrevasses', sortable: false }
      ],
      a2eG2TeamFooterAverages: [],
      a2eG2Title: 'Crevasse Challenge',
      g2TitleMatches: /(crevasse)[^DEMO]/i,
      g3TableHeaders: [
        { text: 'TEAM NAME', value: 'teamName', sortable: false },
        { text: 'TEAM DECISION SCORE', value: 'teamDecisionScore', sortable: false },
        { text: 'TEAM EXPERIENCE SCORE', value: 'experienceScore', sortable: false },
        { text: 'MISSION ACCOMPLISHED', value: 'missionAccomplished', sortable: false },
        { text: 'KEN SAVED', value: 'kenSaved', sortable: false },
        { text: 'RD 1 CORRECT ANSWER', value: 'firstSectionCorrect', sortable: false }
      ],
      a2eG3Scores: [],
      a2eG3TeamFooterAverages: [],
      a2eG3FooterTableHeaders: [
        { text: '% MISSION ACCOMPLISHED', value: 'missionAccomplished', sortable: false },
        { text: '% KEN SAVED', value: 'kenSaved', sortable: false },
        { text: '% ACCOMPLISHED BOTH', value: 'accomplishedBoth', sortable: false }
      ],
      a2eG3Title: 'Mission Nova-Magnetite',
      g3TitleMatches: /(nova)/i,
      csvFields: {
        id: 'id'
      },
      activeTab: 'Survival At Sea'
    }
  },
  computed: {
    placeholderText () {
      if (this.attribute === 'assessment_groups') {
        return 'McKinsey-gbil-1, McKinsey-dna-2'
      } else {
        return '1, 2, 3'
      }
    },
    teamAveragesTitle () {
      if (this.isG2TeamAverageFooterActive) {
        return 'Workshop Averages'
      } else {
        return 'Summary'
      }
    },
    isTeamAverageFooterActive () {
      if (this.isG2TeamAverageFooterActive || this.isG3TeamAverageFooterActive) {
        return true
      }

      return false
    },
    isG1CategoryKeyActive () {
      return this.activeTab === this.a2eG1Title && this.a2eG1Scores.length > 0
    },
    isG2TeamAverageFooterActive () {
      if (this.activeTab === this.a2eG2Title && this.a2eG2Scores.length > 0) {
        return true
      }

      return false
    },
    isG3TeamAverageFooterActive () {
      if (this.activeTab === this.a2eG3Title && this.a2eG3Scores.length > 0) {
        return true
      }

      return false
    }
  },
  methods: {
    csvData () {
    },
    changeTab (gameTitleTabName) {
      this.activeTab = gameTitleTabName
    },
    async getScores () {
      let params = this.query.split(',')
      let trimmedQuery = ''

      if (this.query.length > 0) {
        this.clearPage()
        params.forEach((param, index) => {
          if (index === 0) {
            trimmedQuery = param.trim()
          } else {
            trimmedQuery += `,${param.trim()}`
          }
        })
        let scoresResult = await searchScores({ 'type': this.attribute, 'values': trimmedQuery })

        this.constructFormattedScoringData(scoresResult)
      }
    },
    constructFormattedScoringData (scoresResult) {
      let scoresToFormat = []

      // Dedupe scores of same type, keep most recent
      for (let i = 0; i < scoresResult.items.length; ++i) {
        let scoreMatchIndex = scoresToFormat.findIndex(score => score.name === scoresResult.items[i].name && score.assessment_id === scoresResult.items[i].assessment_id)
        if (scoreMatchIndex !== -1 && scoresToFormat[scoreMatchIndex].id < scoresResult.items[i].id) {
          scoresToFormat.splice(scoreMatchIndex, 1)
          scoresToFormat.push(scoresResult.items[i])
        } else if (scoreMatchIndex === -1) {
          scoresToFormat.push(scoresResult.items[i])
        }
      }

      scoresToFormat.forEach((score) => {
        if (this.g1TitleMatches.test(score.name)) {
          let formattedScore = this.constructG1FormattedScore(score)
          this.a2eG1Scores.push(formattedScore)
        } else if (this.g2TitleMatches.test(score.name) && !score.name.toUpperCase().includes('DEMO')) {
          this.storeG2FormattedScore(score)
        } else if (this.g3TitleMatches.test(score.name)) {
          let formattedScore = this.constructG3FormattedScore(score)
          this.a2eG3Scores.push(formattedScore)
        }
      })

      this.a2eG1Scores.sort((a, b) => {
        let key = 'High Functioning'

        if (a.teamScoreCategory === key && b.teamScoreCategory !== key) {
          return -1
        } else if (a.teamScoreCategory !== key && b.teamScoreCategory === key) {
          return 1
        } else {
          return 0
        }
      })

      this.constructA2eG1FooterText()
      this.constructA2eG2TeamFooterAverages()
      this.constructA2eG3TeamFooterAverages()
    },
    constructG1FormattedScore (g1Score) {
      let formattedScore = {}

      if ('user' in g1Score && 'username' in g1Score.user) {
        formattedScore.teamName = g1Score.user.username
      }

      if ('avgPlayerScore' in g1Score.data) {
        formattedScore.meanIndivScore = parseInt(g1Score.data.avgPlayerScore)
      }

      if ('rankedPlayerScores' in g1Score.data) {
        let bestIndivScore = 0
        g1Score.data.rankedPlayerScores.forEach((playerScore) => {
          if ('score' in playerScore && playerScore.score > bestIndivScore) {
            bestIndivScore = playerScore.score
          }
        })

        formattedScore.bestIndivScore = bestIndivScore
      }

      if ('teamScore' in g1Score.data) {
        formattedScore.overallTeamScore = g1Score.data.teamScore
      }

      return formattedScore
    },
    constructA2eG1FooterText () {
      let teamOutperformedMeanCount = 0
      let teamOutperformedBestCount = 0

      this.a2eG1Scores.forEach((score) => {
        if (score.overallTeamScore > score.bestIndivScore) {
          teamOutperformedBestCount++
          teamOutperformedMeanCount++
        } else if (score.overallTeamScore > score.meanIndivScore) {
          teamOutperformedMeanCount++
        }
      })

      this.a2eG1FooterText1 = `${Math.floor((teamOutperformedMeanCount / this.a2eG1Scores.length) * 100)}% of teams outperformed their mean individual score`
      this.a2eG1FooterText2 = `${Math.floor((teamOutperformedBestCount / this.a2eG1Scores.length) * 100)}% of teams outperformed their best individual score`
    },
    storeG2FormattedScore (g2Score) {
      let formattedScore = {}
      let isCorrectOrder = true // Needs to be G1/G2 (we cant guarantee order of processing).

      let existingScoreInfo = null
      this.a2eG2Scores.forEach((score, index) => {
        if (score.assessmentId === g2Score.assessment_id) {
          existingScoreInfo = { 'score': score, 'index': index }
        }
      })
      let isFirstEntry = existingScoreInfo === null

      if (existingScoreInfo) {
        formattedScore = existingScoreInfo.score

        if (existingScoreInfo.score.name.toUpperCase().includes('LIVE - ROUND 2')) {
          isCorrectOrder = false
        }
      } else {
        formattedScore.name = g2Score.name
        formattedScore.assessmentId = g2Score.assessment_id
      }

      if ('user' in g2Score && 'username' in g2Score.user) {
        formattedScore.teamName = g2Score.user.username
      }

      if ('teamScore' in g2Score.data) {
        let timeMin = Math.floor(g2Score.data.teamScore / 60)
        if (timeMin < 10) {
          timeMin = '0' + timeMin.toString()
        }

        let timeSec = g2Score.data.teamScore % 60
        if (timeSec < 10) {
          timeSec = '0' + timeSec.toString()
        }

        formattedScore.teamScore = this.concatGame2Fields(isCorrectOrder, isFirstEntry, formattedScore.teamScore, `${timeMin}:${timeSec}`)
      }
      if ('numCracks' in g2Score.data) {
        formattedScore.numCracks = this.concatGame2Fields(isCorrectOrder, isFirstEntry, formattedScore.numCracks, g2Score.data.numCracks)
      }
      if ('numCrevasses' in g2Score.data) {
        formattedScore.numCrevasses = this.concatGame2Fields(isCorrectOrder, isFirstEntry, formattedScore.numCrevasses, g2Score.data.numCrevasses)
      }
      if ('timeBeforeFirstClick' in g2Score.data) {
        formattedScore.firstStepTime = this.concatGame2Fields(isCorrectOrder, isFirstEntry, formattedScore.firstStepTime, g2Score.data.timeBeforeFirstClick)
      }

      if (existingScoreInfo) {
        let elapsedTimeSplit = formattedScore.teamScore.split('/')
        if (elapsedTimeSplit.length === 2) {
          let timeElapsedTicksRound1 = this.aggregateG2Average(elapsedTimeSplit[0], 0)
          let timeElapsedTicksRound2 = this.aggregateG2Average(elapsedTimeSplit[1], 0)

          formattedScore.roundTimeDelta = this.convertG2TicksToFormattedA2eTime(Math.abs(timeElapsedTicksRound2 - timeElapsedTicksRound1))
        }
        this.a2eG2Scores[existingScoreInfo.index] = formattedScore
      } else {
        this.a2eG2Scores.push(formattedScore)
      }
    },
    constructA2eG2TeamFooterAverages () {
      let footerAveragesData = {}
      let avgTotalTimeRound1 = 0
      let avgTotalTimeRound2 = 0
      let avgTimeBeforeFirstStepRound1 = 0
      let avgTimeBeforeFirstStepRound2 = 0
      let totalCracksRound1 = 0
      let totalCracksRound2 = 0
      let totalCrevassesRound1 = 0
      let totalCrevassesRound2 = 0
      let avgTimeDelta = 0
      let avgTimeDeltaCompletionCount = 0

      if (this.a2eG2Scores.length > 0) {
        this.a2eG2Scores.forEach((score) => {
          let cracksSplit = score.numCracks.split('/')
          if (cracksSplit.length > 0) {
            totalCracksRound1 += parseInt(cracksSplit[0])
          }
          if (cracksSplit.length > 1) {
            totalCracksRound2 += parseInt(cracksSplit[1])
          }

          let crevassesSplit = score.numCrevasses.split('/')
          if (crevassesSplit.length > 0) {
            totalCrevassesRound1 += parseInt(crevassesSplit[0])
          }
          if (crevassesSplit.length > 1) {
            totalCrevassesRound2 += parseInt(crevassesSplit[1])
          }

          if ('teamScore' in score) {
            let teamScore = score.teamScore.split('/')
            if (teamScore.length > 0) {
              avgTotalTimeRound1 = this.aggregateG2Average(teamScore[0], avgTotalTimeRound1)
            }
            if (teamScore.length > 1) {
              avgTotalTimeRound2 = this.aggregateG2Average(teamScore[1], avgTotalTimeRound2)
            }
          }

          if ('firstStepTime' in score) {
            let timeSplit = score.firstStepTime.split('/')
            if (timeSplit.length > 0) {
              avgTimeBeforeFirstStepRound1 = this.aggregateG2Average(timeSplit[0], avgTimeBeforeFirstStepRound1)
            }
            if (timeSplit.length > 1) {
              avgTimeBeforeFirstStepRound2 = this.aggregateG2Average(timeSplit[1], avgTimeBeforeFirstStepRound2)
            }
          }

          if (score.roundTimeDelta && score.roundTimeDelta.length > 0) {
            avgTimeDelta = this.aggregateG2Average(score.roundTimeDelta, avgTimeDelta)
            avgTimeDeltaCompletionCount++
          }
        })

        avgTotalTimeRound1 = avgTotalTimeRound1 / this.a2eG2Scores.length
        avgTotalTimeRound2 = avgTotalTimeRound2 / this.a2eG2Scores.length
        avgTimeBeforeFirstStepRound1 = avgTimeBeforeFirstStepRound1 / this.a2eG2Scores.length
        avgTimeBeforeFirstStepRound2 = avgTimeBeforeFirstStepRound2 / this.a2eG2Scores.length
        avgTimeDelta = avgTimeDelta / avgTimeDeltaCompletionCount

        footerAveragesData.teamScore = `${this.convertG2TicksToFormattedA2eTime(avgTotalTimeRound1)} / ${this.convertG2TicksToFormattedA2eTime(avgTotalTimeRound2)}`
        footerAveragesData.avgTimeDelta = `${this.convertG2TicksToFormattedA2eTime(avgTimeDelta)}`
        footerAveragesData.firstStepTime = `${this.convertG2TicksToFormattedA2eTime(avgTimeBeforeFirstStepRound1)} / ${this.convertG2TicksToFormattedA2eTime(avgTimeBeforeFirstStepRound2)}`
        footerAveragesData.numCracks = `${parseInt((totalCracksRound1 / this.a2eG2Scores.length))} / ${parseInt((totalCracksRound2 / this.a2eG2Scores.length))}`
        footerAveragesData.numCrevasses = `${parseInt((totalCrevassesRound1 / this.a2eG2Scores.length))} / ${parseInt((totalCrevassesRound2 / this.a2eG2Scores.length))}`
      }

      this.a2eG2TeamFooterAverages.push(footerAveragesData)
    },
    constructG3FormattedScore (g3Score) {
      let formattedScore = {}

      if ('user' in g3Score && 'username' in g3Score.user) {
        formattedScore.teamName = g3Score.user.username
      }

      if ('teamDecisionScore' in g3Score.data) {
        formattedScore.teamDecisionScore = g3Score.data.teamDecisionScore
      }

      if ('experienceScore' in g3Score.data) {
        formattedScore.experienceScore = g3Score.data.experienceScore
      }

      if ('kenSaved' in g3Score.data) {
        if ((typeof (g3Score.data.kenSaved) === 'boolean' && g3Score.data.kenSaved) || (typeof (g3Score.data.kenSaved) !== 'boolean' && g3Score.data.kenSaved.toUpperCase() === this.yesResponseString)) {
          formattedScore.kenSaved = this.yesResponseString
        } else {
          formattedScore.kenSaved = this.noResponseString
        }
      }

      if ('scenario1Correct' in g3Score.data) {
        if (g3Score.data.scenario1Correct) {
          formattedScore.firstSectionCorrect = this.yesResponseString
        } else {
          formattedScore.firstSectionCorrect = this.noResponseString
        }
      }

      if ('missionAccomplished' in g3Score.data) {
        formattedScore.missionAccomplished = g3Score.data.missionAccomplished
      }

      return formattedScore
    },
    constructA2eG3TeamFooterAverages () {
      let footerAveragesData = {}
      let missionAccomplished = 0
      let averageSavedKen = 0
      let accomplishedBoth = 0

      if (this.a2eG3Scores.length > 0) {
        this.a2eG3Scores.forEach((score) => {
          let isMissionAccomplished = false

          if ('missionAccomplished' in score && score.missionAccomplished.toUpperCase() !== this.noResponseString) {
            isMissionAccomplished = true
          }

          let isKenSaved = 'kenSaved' in score && score.kenSaved.toUpperCase() === this.yesResponseString

          if (isMissionAccomplished) {
            missionAccomplished += 1
          }

          if (isKenSaved) {
            averageSavedKen += 1
          }

          if (isKenSaved && isMissionAccomplished) {
            accomplishedBoth += 1
          }
        })

        footerAveragesData.missionAccomplished = `${((missionAccomplished / this.a2eG3Scores.length) * 100).toFixed(2)}%`
        footerAveragesData.kenSaved = `${((averageSavedKen / this.a2eG3Scores.length) * 100).toFixed(2)}%`
        footerAveragesData.accomplishedBoth = `${((accomplishedBoth / this.a2eG3Scores.length) * 100).toFixed(2)}%`
      }

      this.a2eG3TeamFooterAverages.push(footerAveragesData)
    },
    concatGame2Fields (isCorrectOrder, isFirstBoard, formattedScoreData = '', g2ScoreData) {
      if (isFirstBoard) {
        formattedScoreData = `${g2ScoreData}`
      } else if (isCorrectOrder) {
        formattedScoreData += ` / ${g2ScoreData}`
      } else {
        formattedScoreData = `${g2ScoreData} / ${formattedScoreData}`
      }

      return formattedScoreData
    },
    convertG2TicksToFormattedA2eTime (timeTicks) {
      let minElapsed = parseInt(timeTicks / 60)
      let secElapsed = parseInt(timeTicks % 60)

      if (minElapsed < 10) {
        minElapsed = '0' + minElapsed
      }

      if (secElapsed < 10) {
        secElapsed = '0' + secElapsed
      }

      return `${minElapsed}:${secElapsed}`
    },
    aggregateG2Average (timeSplit, currentAggregate) {
      let minSecSplit = timeSplit.split(':')
      let timeMin = parseInt(minSecSplit[0])
      let timeSec = parseInt(minSecSplit[1])

      currentAggregate += timeMin * 60 + timeSec

      return currentAggregate
    },
    clearPage () {
      this.a2eG1Scores = []
      this.a2eG2Scores = []
      this.a2eG3Scores = []

      this.a2eG1FooterText1 = ''
      this.a2eG1FooterText2 = ''
      this.a2eG2TeamFooterAverages = []
      this.a2eG3TeamFooterAverages = []
    }
  }
}
</script>
